<!------------ START TEMPLATE ------------>
<template>
  <div>
    <Modal
      class="holamundo"
      :title="titleSideBar"
      :active.sync="modalForm"
      @close="closeModais"
    >
      <formAddRegional
        :dados="dados"
        @close="closeModais"
        @concluido="concluido"
        :modal="modalForm"
      >
      </formAddRegional>
    </Modal>
    <!------------ START FORM ------------>
    <form role="form" @submit.stop.prevent="onSubmit">
      <!-----============================ OBS: No status deve ter um campo SELECT que irá trazer as opções criadas pelo usuário na parte cadastro de Status do Menu USUARIO  ==================------->
      <div class="vx-row">
        <div class="vx-col mb-6">
          <span>Ativo</span>
          <vs-switch
            color="success"
            v-model="formCadastro.status"
            style="width: 60px"
          >
            <span slot="on">Ativo</span>
            <span slot="off">Inativo</span>
          </vs-switch>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Nome</span>
          <vs-input
            size="large"
            class="w-full"
            name="Nome"
            id="Nome"
            v-model="formCadastro.nome"
            v-validate="{ required: true, min: 6 }"
            :state="validateState('Nome')"
            :danger="validateClass('Nome')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            icon-pack="feather"
            icon="icon-user"
            icon-no-border
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Email</span>
          <vs-input
            type="email"
            size="large"
            class="w-full"
            name="Email"
            id="Email"
            v-model="formCadastro.email"
            v-validate="{ required: true, email: true }"
            :state="validateState('Email')"
            :danger="validateClass('Email')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            icon-pack="feather"
            icon="icon-mail"
            icon-no-border
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>CPF</span>
          <vs-input
            size="large"
            class="w-full"
            name="CPF"
            id="CPF"
            v-model="formCadastro.cpf"
            v-validate="{ required: true, min: 14 }"
            :state="validateState('CPF')"
            :danger="validateClass('CPF')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            v-mask="DOCUMENT_MASK.CPF_ONLY"
            icon-pack="feather"
            icon="icon-user-check"
            icon-no-border
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Celular</span>
          <vs-input
            size="large"
            class="w-full"
            name="Celular"
            id="Celular"
            v-model="formCadastro.celular"
            v-validate="{ required: true }"
            :state="validateState('Celular')"
            :danger="validateClass('Celular')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            v-mask="'(##) #####-####'"
            icon-pack="feather"
            icon="icon-smartphone"
            icon-no-border
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Empresa Vinculada</span>
          <vs-input
            size="large"
            class="w-full"
            name="Empresa Vinculada"
            id="Empresa Vinculada"
            v-model="formCadastro.empresaVinculada"
            val-icon-danger="clear"
            icon-pack="feather"
            icon="icon-map-pin"
            icon-no-border
          />
        </div>
      </div>

      <div class="vx-col w-full">
        <span>Corretora</span>
        <div class="flex">
          <div class="vx-col mb-6 w-5/6">
            <v-select
              :options="regionais"
              name="Corretora"
              id="Corretora"
              class="w-full"
              :create-option="criaRegional"
              v-model="formCadastro.idRegional"
              v-validate="{ required: true }"
              :state="validateState('Corretora')"
              :class="validateClass('Corretora')"
            >
            </v-select>
          </div>

          <div class="vx-col w-1/6 flex justify-end">
            <vs-button
              color="warning"
              type="filled"
              icon="add"
              @click.stop.prevent="openModalInsertEdit"
            ></vs-button>
          </div>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button
            color="warning"
            type="border"
            class="mr-3 mb-2"
            @click.stop.prevent="onReset"
            >Cancelar</vs-button
          >
          <BotaoSubmit
            variant="success"
            :edit="this.dados.idVistoriador == null ? false : true"
            :aguarde="aguardeCadastro"
          ></BotaoSubmit>
        </div>
      </div>
    </form>
    <Modal
      class="holamundo"
      title="Informações da Regional"
      @cancel="clearFormRegional"
      @accept="adicionaRegional"
      :active.sync="activePromptRegionais"
    >
      <div>
        Termine de informar os dados da Regional para
        <b>continuar</b>.
        <vs-input
          placeholder="Estado"
          v-model="formRegional.estado"
          class="mt-4 mb-2 w-full"
        />
        <vs-input
          placeholder="Cidade"
          v-model="formRegional.cidade"
          class="w-full"
        />
        <vs-button color="success" class="w-full mt-2" @click="adicionaRegional"
          >Cadastrar</vs-button
        >
      </div>
    </Modal>

    <!------------ END FORM ------------>
  </div>
</template>
<!------------ END TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import * as lang from 'vuejs-datepicker/src/locale';
import cpfCnpj from '../../services/cpfCnpj';
import service from '../../services';
import BotaoSubmit from '../../components/BotaoSubmit';
import vSelect from 'vue-select';
import formAddRegional from '../forms/formAddRegional.vue';
import Modal from '../../components/Modal.vue';
import { DOCUMENT_MASK } from '../../constants/cpfCnpj';

export default {
  props: {
    sideBar: {
      type: Boolean,
    },
    dados: {
      type: Object,
    },
  },
  watch: {
    dados() {
      this.preencheForm();
    },
  },
  computed: {},
  data() {
    return {
      DOCUMENT_MASK,
      activePromptRegionais: false,
      aguardeCadastro: false,
      idVistoriador: null,
      idEmpresa: null,
      regionais: [],
      regionaisVistoriador: [],
      languages: lang,
      titleSideBar: 'Adicionar Regional',
      dadosSideBar: {},
      modalForm: false,
      formCadastro: {
        idVistoriador: null,
        idEmpresa: null,
        status: true,
        nome: '',
        email: '',
        cpf: '',
        celular: '',
        empresaVinculada: '',
        idRegional: [],
        idRegionais: [],
      },
      formRegional: {
        idEmpresa: '',
        estado: '',
        cidade: '',
        nome: '',
      },
    };
  },
  methods: {
    preencheForm() {
      if (this.dados.idVistoriador) {
        this.formCadastro.idVistoriador = this.dados.idVistoriador;
        this.formCadastro.status = this.dados.deletedAt == null ? true : false;
        this.formCadastro.nome = this.dados.nome;
        this.formCadastro.email = this.dados.email;
        this.formCadastro.cpf = this.dados.cpf;
        this.formCadastro.celular = this.dados.celular;
        this.formCadastro.idRegionais = this.regionaisVistoriador;
        this.formCadastro.empresaVinculada = this.dados.empresaVinculada;
        this.formCadastro.idRegional = {
          id: this.dados.idRegional,
          label: this.dados.Regional,
        };
      } else {
        this.resetForm();
      }
    },

    openModalInsertEdit(dados) {
      const { idRegional } = dados;

      !idRegional
        ? (this.titleSideBar = `Adicionar Regional`)
        : (this.titleSideBar = `Editar Regionais do Vistoriador`);

      this.modalForm = true;
    },
    closeModais(data) {
      this.regionaisVistoriador = data;
      this.formCadastro.idRegionais = this.regionaisVistoriador;
      this.modalForm = false;
    },
    concluido() {
      this.buscaDados();
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    buscaDados() {
      this.selected = [];
      this.$vs.loading();
      service
        .getAll('Vistoriador', {}, 'list/idEmpresa=' + this.idEmpresa)
        .then((res) => {
          this.itens = [];
          this.itensFiltred = [];
          res.data.forEach((element) => {
            let arrAux = [];
            let arrAux2 = [];

            element.Produtos_Grupos.forEach((el) => {
              let obj = {
                idGrupo: el.idGrupo,
                idProduto: el.idProduto,
                idProdutoGrupo: el.idProdutoGrupo,
                nomeGrupo: el.Produtos_grupos.nomeGrupo,
                valor: el.valor,
              };
              arrAux.push(obj);
            });

            element.Produtos_TipoPagamento.forEach((el) => {
              let obj = {
                idTipoPagamento: el.TipoPagamento_Empresa.idTipoPagamento,
                nomePagamento:
                  el.TipoPagamento_Empresa.TipoPagamento_domTipoPagamento
                    .nomePagamento,
                idTipoPagamentoEmpresa: el.idTipoPagamentoEmpresa,
                idProdutoTipoPagamento: el.idProdutoTipoPagamento,
              };
              arrAux2.push(obj);
            });

            element.Grupos = arrAux;
            element.TipoPagamento = arrAux2;

            delete element.Produtos_Grupos;
            delete element.Produtos_TipoPagamento;

            this.itens.push(element);
          });
          this.itensFiltred = [...this.itens];
          this.filtrar(this.ultimoFiltro);
          //this.itens = res.data;
          this.colunas = {};
          if (this.itens[0])
            Object.keys(this.itens[0]).forEach((element) => {
              if (
                element != 'createdAt' &&
                element != 'updatedAt' &&
                element != 'deletedAt' &&
                element.indexOf('id') != 0
              ) {
                this.colunas[element] = element;
              }
            });
          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },
    onSubmit() {
      this.formCadastro.idEmpresa = this.idEmpresa;

      var action = 'Atualizar';
      // eslint-disable-next-line no-unused-vars
      let msgRetorno = 'Dados Atualizados com sucesso';
      if (!this.formCadastro.idVistoriador) {
        action = 'Adicionar';
        msgRetorno = 'Vistoriador Adicionado com sucesso';
      }

      if (cpfCnpj.valida_cpf_cnpj(this.formCadastro.cpf) == false) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: `Este CPF não é válido`,
          color: 'danger',
        });
        return;
      }

      this.$vs.loading();

      this.$validator.validateAll().then((result) => {
        if (result) {
          service
            .post('Vistoriador', action, this.formCadastro)
            .then(() => {
              this.$vs.loading.close();
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: `Operação Realizada com sucesso`,
                color: 'success',
              });
              this.$emit('concluido');
            })
            .catch((error) => {
              this.$vs.loading.close();
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: error,
                color: 'danger',
              });
            });
        } else {
          this.$vs.loading.close();
          this.aguardeCadastro = false;
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Confira os dados e tente novamente.',
            color: 'danger',
          });
        }
      });
    },

    adicionaRegional() {
      if (this.formRegional.estado == '' || this.formRegional.cidade == '') {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Regional não pode ser adicionada',
          color: 'danger',
        });
      } else {
        this.$vs.loading();
        service
          .post('Regional', 'Adicionar', this.formRegional)
          .then((res) => {
            var adicionado = {
              id: res.data.idRegional,
              label: this.formRegional.nome,
            };
            this.regionais.push(adicionado);
            this.formCadastro.idRegional = adicionado;
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: 'Regional adicionada com sucesso',
              color: 'success',
            });
            this.$vs.loading.close();
            this.clearFormRegional();
          })
          .catch(() => {
            this.$vs.loading.close();
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: 'Regional não pode ser adicionada',
              color: 'danger',
            });
          });
      }
    },
    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service
        .getAll('g', {}, `${model}/list/idEmpresa/idEmpresa=${this.idEmpresa}`)
        .then((res) => {
          res.data.forEach((element) => {
            this[array].push({
              id: element[campoPK],
              label: element[campoDescricao],
              estado: element.estado,
              cidade: element.cidade,
            });
          });
        });
    },

    resetForm() {
      this.formCadastro = {
        status: true,
        nome: '',
        email: '',
        cpf: '',
        celular: '',
        idRegional: '',
        regionais: '',
      };
    },
    onReset(evt) {
      if (this.sideBar == true) {
        this.$emit('cancel');
      } else {
        evt.preventDefault();
        this.resetForm();
        this.$nextTick(() => {
          this.show = true;
        });
      }
    },
    criaRegional(event) {
      this.formRegional.idEmpresa = this.idEmpresa;
      this.formRegional.nome = event;
      this.activePromptRegionais = true;
    },
    clearFormRegional() {
      this.activePromptRegionais = false;
      this.formRegional = {
        idEmpresa: '',
        estado: '',
        cidade: '',
        nome: '',
      };
    },
  },
  created() {
    this.buscaDadosSelects('regionais', 'regionais', 'nome', 'idRegional');
  },
  components: {
    BotaoSubmit,
    'v-select': vSelect,
    formAddRegional,
    Modal,
  },
};
</script>
<!------------ END SCRIPT ------------>
